import ProgressBar from '../ProgressBar';
import styles from './AnnotatedProgressBar.scss';
/* eslint-disable react/prop-types */ // TODO: add props

const AnnotatedProgressBar = ({ value, total, tooltipText = '', children }) => {
  const isInvalid = isNaN(total) || isNaN(value) || total < 0 || value < 0;

  return (
    <div title={isInvalid ? '' : tooltipText}>
      <div className={styles.progressBarWrapper}>
        <ProgressBar value={value} total={total} />
      </div>

      <div className={styles.progressBarAnnotation}>
        {isInvalid ? 'N/A' : children}
      </div>
    </div>
  );
};

export default AnnotatedProgressBar;
